export class PersonalLaboratoryResultModel {
    personalLaboratoryResultId: number;
    personalLaboratoryResultName: string;
    minValue: number;
    maxValue: number;
}